import React from 'react';
import PropTypes from 'prop-types';

import Divider from '@material-ui/core/Divider';
import MenuItem from '@material-ui/core/MenuItem';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import LinearProgress from '@material-ui/core/LinearProgress';
import TextField from '@material-ui/core/TextField';

import AddCircleIcon from '@material-ui/icons/AddCircle';
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import EditIcon from '@material-ui/icons/Edit';

import DataTableToolbar from '../_Shared/DataTables/DataToolbar';
import DataTable from '../_Shared/DataTables/DataTable';
import CreateModal from '../_Shared/CreateModal';
import AppContent from '../_Shared/Layout/AppContent';

const defaultRole = { name: '', postClickLookback: 30, postViewLookback: 30, costModifier: 1.25 }
const uuidv4 = require('uuid/v4');

class RoleList extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            showCreateModal: false,
            role: defaultRole,
            anchorEl: null
        }
        this.handleInputChange = this.handleInputChange.bind(this);
    }

    toggleRowMenu = currentTarget => {
        this.setState((prevState) => {
            return { anchorEl: prevState.anchorEl === currentTarget ? null : currentTarget }
        })
    }

    closeToggleRowMenu = () => {
        this.setState({ anchorEl: null });
    }

    toggleCreateModal = e => {
        const { showCreateModal } = this.state;
        this.setState({ showCreateModal: !showCreateModal, role: defaultRole });
    }

    selectElement = role => {
        this.setState({ role });
    }

    handleInputChange = event => {
        const { target: { name, value } } = event;
        this.setState((prevState, state) => {
            return {
                role: Object.assign({}, prevState.role, { [name]: value, })
            }
        });
    }

    createRole = e => {
        const { role } = this.state;
        this.props.onRoleAdded(Object.assign({}, role, { id: uuidv4().replace(/-/g, '') }));
        this.setState({ showCreateModal: false });
    }
    
    deleteRole = event => {
        const { role } = this.state;
        this.props.onRoleRemoved(role);
        this.setState({ role: defaultRole, anchorEl: null });
    }

    render() {
        const { roles, onEdit, loading } = this.props;
        const { showCreateModal, role, anchorEl } = this.state;
        return (<AppContent>
            {
                loading && <LinearProgress variant="query" />
            }
            <DataTableToolbar title="Roles" numSelected={0} >
                <Tooltip title="Add New">
                    <IconButton onClick={this.createRole} color="secondary"><AddCircleIcon /></IconButton>
                </Tooltip>
            </DataTableToolbar>
            {
                roles &&
                <DataTable columns={[{ label: 'Name', field: 'name' }]} anchorEl={anchorEl} rows={roles}
                    toggleRowMenu={this.toggleRowMenu} onElementSelect={this.selectElement} onCloseToggleRowMenu={this.closeToggleRowMenu}>
                    <MenuItem onClick={() => onEdit(`/system/roles/${role.id}/manage/settings`, role)}>
                        <ListItemIcon><EditIcon /></ListItemIcon>
                        <ListItemText inset primary="Settings" />
                    </MenuItem>
                    <Divider />
                    <MenuItem onClick={this.deleteRole}>
                        <ListItemIcon><DeleteForeverIcon /></ListItemIcon>
                        <ListItemText inset primary="Delete" />
                    </MenuItem>
                </DataTable>
            }
            <CreateModal title="Create Role" open={showCreateModal} closeHandler={this.toggleCreateModal} saveHandler={this.onCreateNew}>
                <TextField autoFocus value={role.name} onChange={this.handleInputChange} id="name" name="name" label="Role Name" type="text" fullWidth />
                <TextField value={role.costModifier} onChange={this.handleInputChange} id="costModifier" name="costModifier" label="Cost Modifier" type="number" />
                <TextField value={role.postClickLookback} onChange={this.handleInputChange} id="postClickLookback" name="postClickLookback" label="Post Click Lookback" type="number" />
                <TextField value={role.postViewLookback} onChange={this.handleInputChange} id="postViewLookback" name="postViewLookback" label="Post View Lookback" type="number" />
            </CreateModal>
        </AppContent>)
    }
}

RoleList.propTypes = {
    roles: PropTypes.array.isRequired,
};

export default RoleList;


// WEBPACK FOOTER //
// ./src/Components/Presentation/Roles/RoleList.js